import { useMemo, useState } from 'react';

import { getYear } from '../../../utils/date';
import { Cell } from '../Cell';
import { Controls } from '../Controls';

type Props = {
  selectedYear?: number;
  initialYear: number;
  onSelectYear: (_year: number) => void;
  minDate?: number;
  maxDate?: number;
};

export const YearView = ({ selectedYear, initialYear, onSelectYear, minDate, maxDate }: Props) => {
  const [maxYearBound, setMaxYearBound] = useState(initialYear + (10 - (initialYear % 10)));

  const { maxYear, minYear } = useMemo(() => {
    const maxYear = maxDate ? getYear(maxDate) : undefined;
    const minYear = minDate ? getYear(minDate) : undefined;

    return { maxYear, minYear };
  }, [maxDate, minDate]);

  const handlePrevious = () => {
    setMaxYearBound(p => p - 10);
  };

  const handleNext = () => {
    setMaxYearBound(p => p + 10);
  };

  return (
    <div>
      <Controls
        onPrevious={handlePrevious}
        onNext={handleNext}
        label={`${maxYearBound - 11} - ${maxYearBound}`}
        isNextDisabled={!!maxYear && maxYearBound >= maxYear}
        isPreviousDisabled={!!minYear && maxYearBound - 11 <= minYear}
      />
      <div className="w-64 grid grid-cols-4">
        {Array.from({ length: 12 })
          .map((_, index) => {
            const indexYear = maxYearBound - index;

            return (
              <Cell
                key={indexYear}
                isSelected={selectedYear === indexYear}
                onClick={() => onSelectYear(indexYear)}
                isDisabled={(!!maxYear && indexYear > maxYear) || (!!minYear && indexYear < minYear)}
              >
                {indexYear}
              </Cell>
            );
          })
          .reverse()}
      </div>
    </div>
  );
};
